import React from 'react';
import { motion } from 'framer-motion';
import { useScrollReveal } from '../../hooks/useScrollAnimations';

const media = [
  { type: 'video', src: '/content/tmf data/test-img/MOV to MP4 Conversion.mp4' },
  { type: 'video', src: '/content/tmf data/test-img/MOV to MP4 Conversion (1).mp4' },
  { type: 'video', src: '/content/tmf data/test-img/MOV to MP4 conversion (2).mp4' },
  { type: 'image', src: '/content/tmf data/test-img/24158c2b-dde3-4438-83b0-75ffaed456a9.JPG' },
  { type: 'image', src: '/content/tmf data/test-img/HEIC to JPG Image.jpg' },
  { type: 'image', src: '/content/tmf data/test-img/HEIC to JPG 0244.jpg' },
  { type: 'image', src: '/content/tmf data/test-img/IMG 2347.jpg' },
  { type: 'image', src: '/content/tmf data/test-img/IMG 2392.jpg' },
  { type: 'image', src: '/content/tmf data/test-img/IMG 2393.jpg' },
  { type: 'image', src: '/content/tmf data/test-img/IMG 2394.jpg' },
  { type: 'image', src: '/content/tmf data/test-img/IMG 2395.jpg' },
  { type: 'image', src: '/content/tmf data/test-img/cc16bc5d-aeaf-48ce-b5d4-677b5f608174.JPG' },
];

const SolutionSection: React.FC = () => {
  const { ref: titleRef, isInView: titleInView } = useScrollReveal(0.3);
  const { ref: contentRef, isInView: contentInView } = useScrollReveal(0.2);

  return (
    <section className="tmf-solution green-accent">
      <div className="tmf-container">
        {/* Section Title */}
        <motion.div
          ref={titleRef}
          initial={{ opacity: 0, y: 50 }}
          animate={titleInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="tmf-section-header"
        >
          <h2 className="tmf-section-title">Putting It to the Test</h2>
          <p className="tmf-section-intro">
            We ran our first pilots on November 6th and 13th, 2024, just before the Thanksgiving season hit. We anticipated the most participation during this time, and people did show up.
          </p>
        </motion.div>

        {/* Pilot Test Media Grid */}
        <motion.div
          ref={contentRef}
          initial={{ opacity: 0 }}
          animate={contentInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.8 }}
          className="tmf-test-media-grid"
        >
          {media.map((item, index) => (
            <motion.div
              key={index}
              className="tmf-test-media-item"
              initial={{ opacity: 0, y: 30 }}
              animate={contentInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              {item.type === 'video' ? (
                <video
                  src={item.src}
                  muted
                  autoPlay
                  loop
                  playsInline
                  preload="auto"
                  className="tmf-test-video"
                />
              ) : (
                <img
                  src={item.src}
                  alt={`Pilot test ${index + 1}`}
                  className="tmf-test-image"
                />
              )}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default SolutionSection;
